import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import classNames from "classnames/bind";
import styles from "./Sidebar.module.scss";
import { IoIosArrowDown } from "react-icons/io";

const cx = classNames.bind(styles);

export default function Sidebar({ list }) {
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState(null);

  // ✅ 현재 경로에 따라 초기 열린 메뉴 자동 설정
  useEffect(() => {
    // path 배열 안의 하위 메뉴 중, 현재 경로가 포함된 상위 메뉴 찾기
    const parent = list.find(
      (item) =>
        Array.isArray(item.path) &&
        item.path.some((sub) => location.pathname.startsWith(sub.path))
    );

    if (parent) {
      setOpenMenu(parent.id);
    } else {
      setOpenMenu(null);
    }
  }, [location.pathname, list]);

  const toggleMenu = (id) => {
    setOpenMenu(openMenu === id ? null : id);
  };

  return (
    <div className={cx("container")}>
      <div className={cx("logo_box")}>
        <img
          src="/images/kcmc-logo.png"
          alt="KCMC Logo"
          className={cx("logo")}
        />
      </div>

      <div>
        {list.map((item) => (
          <div className={cx("list_box")} key={item.id}>
            {Array.isArray(item.path) ? (
              <>
                {/* 부모 메뉴 */}
                <button
                  type="button"
                  className={cx(
                    "list_button_link",
                    "parent_button",
                    openMenu === item.id && "active_parent"
                  )}
                  onClick={() => toggleMenu(item.id)}
                >
                  <span className={cx("menu_left")}>{item.title}</span>
                  <IoIosArrowDown
                    className={cx("arrow_icon", {
                      open: openMenu === item.id,
                    })}
                  />
                </button>

                {/* 하위 메뉴 */}
                {openMenu === item.id && (
                  <div className={cx("sub_list_box")}>
                    {item.path.map((sub) => (
                      <NavLink
                        key={sub.id}
                        to={sub.path}
                        className={() =>
                          cx(
                            location.pathname.startsWith(sub.path)
                              ? "active_sub_list_button_link"
                              : "sub_list_button_link"
                          )
                        }
                      >
                        {sub.icon}
                        {sub.title}
                      </NavLink>
                    ))}
                  </div>
                )}
              </>
            ) : (
              // 단일 메뉴
              <NavLink
                to={item.path}
                className={() =>
                  cx(
                    location.pathname.startsWith(item.path)
                      ? "active_list_button_link"
                      : "list_button_link"
                  )
                }
              >
                {item.icon}
                {item.title}
              </NavLink>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
